export const BaseIpAuth = "https://testcockpitauth.p2k.in/";

export const BaseIp = "https://testcockpit.p2k.in/"

export const BaseURlAuth = BaseIpAuth + "api/";

export const BaseURl = BaseIp + "api/";
